var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_50",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m52.856,11.797c0-.529-.425-.944-.944-.944h-3.833c-.519,0-.944.415-.944.944v4.326h5.721v-4.326Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m60.417,44.893l-4.796-4.324c-.661-.595-1.01-1.463-.935-2.341l.483-9.077c.045-.547-.009-1.103-.161-1.632l-2.002-7.803c-.094-.34-.151-.699-.151-1.057v-2.537h-5.721v2.537c0,.359-.047.717-.151,1.057l-2.002,7.803c-.152.529-.206,1.085-.161,1.632l.483,9.077c.076.878-.264,1.746-.925,2.341l-4.805,4.324c-.84.755-1.293,1.841-1.246,2.964l1.794,38.553c.047.906.812,1.812,1.699,2.001,2.247.491,5.211.736,8.175.736s5.928-.245,8.175-.736c.897-.189,1.661-1.095,1.709-2.001l1.794-38.553c.047-1.123-.415-2.209-1.256-2.964Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }